var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconScreenmodeSystem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23,4v5h-5v-2h1.46c-1.62-2.41-4.35-4-7.46-4C7.38,3,3.56,6.51,3.06,11H1.05C1.56,5.4,6.27,1,12,1c3.72,0,7.01,1.87,9,4.71v-1.71h2ZM12,21c-3.11,0-5.85-1.59-7.46-4h1.46v-2H1v5H3v-1.71c1.99,2.84,5.28,4.71,9,4.71,5.73,0,10.44-4.4,10.95-10h-2.01c-.5,4.49-4.32,8-8.94,8Zm-4-8.26v-1.48l-1.7-1.4,1-1.73,2.06,.77,1.28-.74,.36-2.17h2l.36,2.17,1.28,.74,2.06-.77,1,1.73-1.7,1.4v1.48l1.7,1.4-1,1.73-2.06-.77-1.28,.74-.36,2.17h-2l-.36-2.17-1.28-.74-2.06,.77-1-1.73,1.7-1.4Zm2-.74c0,1.1,.9,2,2,2s2-.9,2-2-.9-2-2-2-2,.9-2,2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconScreenmodeSystem);
export default __webpack_public_path__ + "static/1770312069/media/icon-screenmode-system.fb999ecb1e0df9dcaebbe6e15b1596ac.svg";
export { ForwardRef as ReactComponent };